import { PORTAL_PUBLICATION_STATUSES } from "../lib/portalPublicationsApi.js";

const DRIVER_PORTAL_ACTIVE_ACCENT_COLOR = "rgba(11, 107, 58, 0.92)";
const DISPATCH_DISABLED_ACCENT_COLOR = "var(--hovercard-accent-warning)";
const TRUCK_PROTECTION_ACCENT_COLOR = "rgba(15, 92, 87, 0.92)";

export function buildDriverPortalStatusHoverCardContent(status, isDispatchDisabled = false) {
  const isPublished = status === PORTAL_PUBLICATION_STATUSES.published;

  if (isPublished) {
    return {
      title: isDispatchDisabled
        ? "Portail actif · camion hors dispatch"
        : "Portail du chauffeur est actif sur la plateforme",
      description: isDispatchDisabled
        ? "Le portail reste accessible et indique au chauffeur que son camion est hors service pour cette journée."
        : "La tournée de ce camion est publiée et visible dans le portail chauffeur.",
      accentColor: DRIVER_PORTAL_ACTIVE_ACCENT_COLOR,
    };
  }

  return {
    title: "Tournée non publiée dans le portail chauffeur",
    description: "La tournée de ce camion n'est pas encore visible dans le portail chauffeur.",
    accentColor: "var(--hovercard-accent-neutral)",
  };
}

export function buildDispatchDisabledHoverCardContent(dispatchDisabledBadge) {
  if (!dispatchDisabledBadge) {
    return null;
  }

  return {
    title: dispatchDisabledBadge.isEndOfDayLoadTransit ? "Camion chargé en PM" : "Camion hors dispatch",
    description: dispatchDisabledBadge.isEndOfDayLoadTransit
      ? dispatchDisabledBadge.title.replace(/\s+Non disponible ce jour\.$/, "\nNon disponible ce jour.")
      : dispatchDisabledBadge.title,
    accentColor: DISPATCH_DISABLED_ACCENT_COLOR,
  };
}

export function buildTruckProtectionHoverCardContent(truckProtectionBadge) {
  if (!truckProtectionBadge) {
    return null;
  }

  return {
    title: "Le camion est protégé",
    description: truckProtectionBadge.title,
    accentColor: TRUCK_PROTECTION_ACCENT_COLOR,
  };
}
